import PanelShipping from './components/PanelShipping';
export default PanelShipping;